import { render, staticRenderFns } from "./addSlabs.vue?vue&type=template&id=7d565ffd&scoped=true"
import script from "./addSlabs.vue?vue&type=script&lang=js"
export * from "./addSlabs.vue?vue&type=script&lang=js"
import style0 from "./addSlabs.vue?vue&type=style&index=0&id=7d565ffd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d565ffd",
  null
  
)

export default component.exports